export default __webpack_public_path__ + "static/media/what-we-do-bg.70b89bba.webp";